module.exports = __webpack_public_path__ + "static/media/arthur-cox.b07bcfb4.jpg";